import { useQuery } from '@tanstack/react-query';

import * as LoyaltyService from '~/services/LoyaltyService';

import { pointsPurchaseQueryKeys } from './pointsPurchaseQueryKeys';

export function useGetPointsPurchaseOffers(currency = 'AUD') {
  return useQuery({
    queryKey: pointsPurchaseQueryKeys.offersByCurrency(currency),
    queryFn: async () => LoyaltyService.listPointsPurchaseOffers(currency),
  });
}
